import React from "react";
import { Link } from 'react-router-dom';

import img1 from "../../Assets/relatedProduct/3pinSocket.webp";
import img2 from "../../Assets/relatedProduct/CMS.webp";
import img3 from "../../Assets/relatedProduct/Simulator.webp";
import img4 from "../../Assets/relatedProduct/Type2.webp";
import img5 from "../../Assets/relatedProduct/acdevkit.webp";
import img6 from "../../Assets/relatedProduct/levdc.webp";
import img7 from "../../Assets/relatedProduct/accharger.webp";
import img8 from "../../Assets/relatedProduct/dccharger.webp";


// Master lookup — keyed by a short id you'll reference from pages
const PRODUCT_MAP = {
    cms: {
        title: "CMS",
        description: "Add remote monitoring and management capabilities to your AC charger development setup.",
        image: img2,
        link: "/cms",
    },
    type2: {
        title: "Type 2 Charging Gun",
        description: "Add Type 2 charging connectivity for testing and evaluating AC charging solutions.",
        image: img4,
        link: "https://www.amazon.in/dp/B0F9K3JH41",
    },
    simulator: {
        title: "EV Simulator",
        description: "Simulate EV charging behaviour and communication for development and testing.",
        image: img3,
        link: "/evsimulator",
    },
    socket3pin: {
        title: "3 pin Socket",
        description: "Add a 3-pin output option for flexible AC charging solution development and testing.",
        image: img1,
        link: "",
    },
    acdevkit: {
        title: "AC Development Kit",
        description: "A comprehensive kit for developing and testing AC charging solutions.",
        image: img5,
        link: "/acdevelopmentkit",
    },
    acchargers: {
        title: "AC Chargers",
        description: "Explore VerdeMobility’s AC EV chargers for safe, efficient, and reliable charging at homes, workplaces, and commercial locations.",
        image: img7,
        link: "/hardware#ac-chargers",
    },
    dcchargers: {
        title: "DC Chargers",
        description: "Explore VerdeMobility’s DC fast chargers for high-performance charging at commercial, fleet, highway, and public locations.",
        image: img8,
        link: "/hardware#dc-chargers",
    },
    levdc: {
        title: "LEVDC Chargers",
        description: "Explore the all-new LEV DC Chargers, designed for fast, reliable charging across the light EV ecosystem.",
        image: img6,
        link: "/levdc",
    }
};

const DEFAULT_PRODUCTS = ["cms", "type2", "simulator", "socket3pin", "acdevkit", "acchargers", "dcchargers", "levdc"];

const RelatedProduct = ({ title, products = DEFAULT_PRODUCTS }) => {
    // keep only valid ids, preserve the order the page passed in, cap at 4
    const cards = products
        .map((id) => PRODUCT_MAP[id])
        .filter(Boolean)
        .slice(0, 4);

    if (cards.length === 0) return null;

    return (
        <section className="blade-margin-top-sm">
            <div className="containers-min mx-auto px-4 py-12">
                {title && <h3 className="font-gilroy mb-4 h3 text-4xl">{title}</h3>}
                <div className="flex gap-4 flex-wrap lg:flex-nowrap justify-around">
                    {cards.map((card, i) => (
                        <div key={i}>
                            <DataCard {...card} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const DataCard = ({ title, description, image, link }) => {
    const isExternal = link?.startsWith("http");
    const isClickable = Boolean(link);

    const content = (
        <div className="group h-[225px] Lg:h-[380px] xxl:h-[280px] overflow-hidden grow-0 relative">
            <img
                loading="lazy"
                src={image}
                alt={title}
                className="h-full w-full object-cover "
            />

            <div className="absolute bottom-0 left-0 right-0 bg-gradient-opa py-3 px-4 text-center transition-opacity duration-500 group-hover:opacity-0 z-10">
                <span className="text-xl font-bold font-gilroy">
                    {title}
                </span>
            </div>

            <div className="absolute inset-0 bg-gradient-opa transform translate-y-full group-hover:translate-y-0 transition-transform duration-[1s] flex flex-col items-center justify-center text-center px-4 gap-3 z-20">
                <span className="text-3xl font-bold font-gilroy">
                    {title}
                </span>
                <div className="leading-normal font-poppins text-center text-lg max-w-[90%]">
                    <p className="leading-normal font-poppins text-start text-lg">{description}</p>
                </div>
            </div>
        </div>
    );

    const sharedClassName =
        "basis-96 relative flex flex-col self-stretch grow shrink mx-auto rounded-2xl overflow-hidden group" +
        (isClickable ? " cursor-pointer" : " cursor-default");

    if (!isClickable) {
        return <div className={sharedClassName}>{content}</div>;
    }

    return (
        <Link
            to={link}
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noopener noreferrer" : undefined}
            className={sharedClassName}
        >
            {content}
        </Link>
    );
};

export default RelatedProduct;